<template>
  <div
    class="login-container"
    :style="
      setBackgroundImg(!isShow ? store.state.backgroundImg : store.state.isCode)
    "
  >
    <div style="padding: 36px 78px">
      <p style="color: #fff; font-size: 30px; font-weight: bolder">
        智慧高校学院服务大厅
      </p>
      <p style="color: #fff; font-size: 20px; line-height: 36px">
        精益求精，高校驾驭每一天
      </p>
    </div>
    <div id="captcha-box"></div>
    <div class="login-content">
      <div class="content-right">
        <!--        <span class="content-right-line"></span>-->
        <!--        <span class="content-right-line-two"></span>-->
        <!--        <p class="content-right-text">{{ store.state.systemName }}</p>-->
        <div class="content-right-login v-text-center">用户登录</div>
        <el-tabs v-model="activeName" class="demo-tabs v-m-b-10">
          <el-tab-pane label="账号登录" name="0"></el-tab-pane>
        </el-tabs>
        <el-form :model="form" ref="formRef" :rules="rules">
          <el-form-item prop="username">
            <el-input v-model="form.username" placeholder="请输入账号">
              <template #prefix>
                <div class="a-input__icon">
                  <img src="@/assets/imgs/login-user.png" alt="" />
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="form.password"
              placeholder="请输入密码"
              show-password
            >
              <template #prefix>
                <div class="a-input__icon">
                  <img src="@/assets/imgs/login-password.png" alt="" />
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="login-btn"
              type="primary"
              v-if="!isvalidate"
              @click="handleBlur"
              >点击验证
            </el-button>
          </el-form-item>
          <el-checkbox
            v-if="isvalidate"
            v-model="rememberMeFlag"
            label="记住我"
          />
          <div v-if="isvalidate" style="color: #03a55a">验证成功！</div>
          <el-form-item>
            <el-button
              class="login-btn"
              type="primary"
              v-if="isvalidate"
              @click="submit"
              :loading="loading"
              >登录
            </el-button>
          </el-form-item>
          <el-form-item class="forgetpwd-btn">
            <!--            <span @click="forgetPassword">忘记密码？</span>-->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="footer">Copyright ©2006 - 2024 巨软科技版权所有</div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import "@/assets/styles/tac.css"; // 验证码css
import "@/assets/tac.min.js"; // 验证码js
const store = useStore();
import { localCache } from "@/utils/Cache";
import { ElMessage } from "element-plus";
import qs from "qs";
import { useRouter } from "vue-router";
import { getParams } from "@/utils/getParams";
import oauth2Config from "@/config/oauth2Config";
import { getUserPage, isLogin } from "@/common/api/http.api.login";

const router = useRouter();
const activeName = ref("0");
// 校验
const rules = {
  username: [
    {
      required: true,
      message: "请输入账号",
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      message: "请输入密码",
      trigger: "blur",
    },
  ],
  validation: [
    {
      required: true,
      message: "请输入验证码",
      trigger: "blur",
    },
  ],
};
const form = ref({
  username: "adminSystem",
  password: "123456",
});
const isvalidate = ref(false);
const id = ref();
// 触发验证码
const slideValidate = ref();
const handleBlur = () => {
  if (!form.value.username) {
    ElMessage.warning("请输入账号");
    return;
  } else if (!form.value.password) {
    ElMessage.warning("请输入密码");
    return;
  }
  if (slideValidate.value != null) {
    document.getElementById("captcha-box").innerHTML = "";
  }
  if (form.value.username && form.value.password) {
    // 样式配置
    const config = {
      requestCaptchaDataUrl:
        "/college_service_hall_api/verificationCode/generateVerificationCode",
      validCaptchaUrl:
        "/college_service_hall_api/verificationCode/checkVerificationCode",
      bindEl: "#captcha-box",
      // 验证成功回调函数
      validSuccess: (res, c, tac) => {
        isvalidate.value = true;
        id.value = res.data.id;
        tac.destroyWindow();
      },
    };
    slideValidate.value = new window.TAC(config).init();
  }
};
const rememberMeFlag = ref();

// 登录
function submit() {
  formRef.value.validate((valid) => {
    if (valid) {
      isLogin({
        username: form.value.username,
        password: form.value.password,
        verificationCodeId: id.value,
        loginDevice: "pc",
        rememberMeFlag: rememberMeFlag.value ? "1" : "",
      }).then((res) => {
        localCache.setCache("roleList", JSON.stringify(res.data.roleList));
        localCache.setCache("userData", JSON.stringify(res.data?.userInfo));
        let roleCode = res.data?.roleList?.map((m) => m.roleCode);
        if (roleCode?.includes("super_admin")) {
          localCache.setCache("isAdmin", true);
        }
        localCache.setCache("collegeToken", res.data?.token);
        // 获取用户菜单
        getUserPage({
          clientId: 1,
        }).then((res) => {
          localCache.setCache("menuAuth", JSON.stringify(res.data));
          localCache.setCache(
            "permissionList",
            JSON.stringify(res.permissionList)
          );
          if (getParams(window.location.hash.split("?")[1])?.client_id) {
            var authorUrl = oauth2Config.userAuthorizationUri;
            authorUrl =
              authorUrl +
              ("?" +
                qs.stringify({
                  client_id: getParams(window.location.hash.split("?")[1])
                    ?.client_id,
                  response_type: "code",
                  scope: "userinfo",
                  redirect_uri: getParams(window.location.hash.split("?")[1])
                    ?.redirect_uri,
                }));
            window.location.href = authorUrl;
          } else {
            router.push("/home");
          }
        });
      });
    } else {
      return false;
    }
  });
}

const formRef = ref();
const loading = ref(false);
const isShow = ref(false);
// 设置背景图片
const setBackgroundImg = (img) => {
  if (img == "" || img == undefined) {
    return { background: "#1e9fff" };
  } else {
    return {
      background: "url(" + img + ") center no-repeat",
      backgroundSize: "100% 100%",
    };
  }
};
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
  #tianai-captcha-parent {
    width: 100%;
  }
  #captcha-box {
    position: absolute;
    left: calc(50% - 159px);
    top: 25%;
  }
  .login-container {
    display: block !important;
    height: 100%;
    background-size: 100% 100%;
    overflow: hidden;

    .title {
      font-size: 22px;
      color: #fff;
    }

    .footer {
      width: 100%;
      height: 5%;
      color: #fff;
      text-align: center;
      position: fixed;
      bottom: 0;
    }

    .login-content {
      display: flex;
      justify-content: end;
      margin-right: 300px;
      margin-top: 78px;
    }

    .content-right {
      width: 22%;
      padding: 1% 2%;
      box-sizing: border-box;
      background: #fff;
      box-shadow: 0px 6px 13px rgb(58 9 123 / 35%);
      border-radius: 10px;
      min-width: 346px;
    }

    .content-right-line {
      display: inline-block;
      width: 45px;
      height: 6px;
      background: #1e9fff;
      opacity: 1;
      border-radius: 4px;
      margin: 0 10px;
    }

    .content-right-line-two {
      display: inline-block;
      width: 14px;
      height: 6px;
      background: #1e9fff;
      opacity: 1;
      border-radius: 4px;
    }

    .content-right-text {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #1e9fff;
      margin-bottom: 10px;
    }

    .content-right-login {
      // display: inline-block;
      line-height: 60px;
      font-size: 24px;
      color: #000000;
    }

    .a-input__icon {
      padding-right: 13px;
      border-right: 1px solid #d4d4d4;
      padding-top: 5px;
    }

    .login-btn {
      width: 100%;
      height: 48px;
      color: #fff;
      font-size: 20px;
      margin-top: 10%;
    }

    .ant-input-affix-wrapper {
      border-radius: 6px;
    }

    .content-right-yanzheng {
      display: flex;
      justify-content: space-between;
    }

    .content-right-erweima {
      cursor: pointer;
    }

    .forgetpwd-btn {
      color: #999999;
    }

    ::v-deep .el-form-item {
      margin-bottom: 18px;
    }
  }
  ::v-deep .el-dialog {
    min-width: 500px;
  }
  .login-mobile {
    display: none !important;
  }
  ::v-deep .el-form-item__content {
    flex-wrap: nowrap;
  }
  ::v-deep .el-checkbox__label {
    color: #409eff;
  }
  ::v-deep #tianai-captcha-parent .slider-bottom .logo {
    display: none;
  }
}

/*定义竖屏 css*/
@media screen and (orientation: portrait) {
  .login-mobile {
    display: block;

    .login_title {
      position: absolute;
      top: 1rem;
      left: 1rem;
    }
  }
  .login-container {
    display: none;
  }
  .login_form {
    padding: 1rem 1rem 0 1rem;

    .el-form {
      margin-top: 1rem;

      .form_label {
        border-right: 1px solid #efefef;
        padding-right: 0.5rem;
      }

      .login-btn {
        width: 100%;
        height: 48px;
        color: #fff;
        font-size: 20px;
        background: #1e9fff;
      }

      .content-right-erweima {
        cursor: pointer;
      }

      .forgetpwd-btn {
        color: #666;
      }

      :deep(.el-input__wrapper) {
        box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>
